<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation style="
        box-shadow: -6px 0px 10px black;
        background: linear-gradient(to bottom, #2d318e, #0065a5, #2d318e);
    " class="dark print:hidden" [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'"
    [navigation]="navigation.default" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- User Logo Section -->
        <div class="flex flex-col items-center w-full" style="background: url('assets/images/background/wave.svg')">
            <div class="relative mb-8 mt-6 image-layer">
                <img src="assets/images/logo/EQWellsite.png" alt="EQWellsite" />
            </div>
        </div>
    </ng-container>

    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-12">
            <img class="max-w-36" src="assets/images/logo/logo-text-on-dark.svg" alt="Wellbarrier" />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>

        <!-- Header Actions -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!-- Current Date -->
            <div class="px-4">{{ currentDate | date:'EEEE, d MMM yyyy' }}</div>
            <div class="divider divider-horizontal"></div>

            <!-- Notifications -->
            <notifications></notifications>

            <!-- User Menu -->
            <details class="dropdown dropdown-end px-4">
                <summary class="btn remove-bg p-2">
                    <div class="avatar placeholder">
                        <mat-icon class="rounded-full w-14" style="height: 30px"
                            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                    </div>
                </summary>

                <ul class="p-2 shadow border menu dropdown-content z-[1] bg-base-100 rounded-box w-80">
                    <div class="grid grid-cols-4 gap-2 p-2">
                        <mat-icon matTooltip="Full Name" class="place-self-center"
                            style="width: 10px;height: 10px;font-size: 10px;" svgIcon="mat_solid:person"></mat-icon>
                        <div class="col-span-3 font-semibold" style="color: #0f172a"> {{ user?.name}} </div>

                        <mat-icon matTooltip="Email" class="place-self-center"
                            style="width: 10px;height: 10px;font-size: 10px;" svgIcon="mat_outline:email"></mat-icon>
                        <div class="col-span-3" style="color: #06453f"> {{ user?.email }} </div>

                        <mat-icon matTooltip="Roles" class="place-self-center"
                            style="width: 10px;height: 10px;font-size: 10px;"
                            svgIcon="mat_outline:assignment_ind"></mat-icon>
                        <div class="col-span-3">
                            <ng-container *ngIf="user?.roles.length > 0">
                                <div class="badge mt-1 p-3" style="font-size: 12px;" *ngFor="let role of user?.roles">
                                    {{ role }} </div>
                            </ng-container>
                        </div>


                    </div>
                    <hr style="margin: 0px;" />

                    <button mat-button color="warn" (click)="signOut()"> sign out </button>
                </ul>
            </details>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <router-outlet></router-outlet>
    </div>
</div>